import type { Schema } from '@cli-types/core-engine/schema.js'
import type { EntityFieldContext } from '@cli-types/next-adapter/generators.js'
import { flattenFields } from '@core-engine/schema/field-helpers/flattening/flatten-fields.js'
import { isLayoutField } from '@core-engine/schema/field-type-guards/is-layout-field.js'
import { createAuthorshipFields } from '@next-adapter/generators/actions/action-helpers/create-authorship-fields.js'
import { createAutoField } from './create-auto-field.js'
import { getSchemaFieldByName } from './get-schema-field-by-name.js'

export function getEntityFieldContext(schema: Schema): EntityFieldContext {
  const dbFields = flattenFields(schema.fields).filter((field) => !isLayoutField(field.type))
  const regularDbFields = dbFields.filter(
    (field) => !(field.type === 'relationship' && field.multiple === true)
  )

  const allDbFields = [...regularDbFields]

  if (schema.actions?.draft === true && !getSchemaFieldByName(allDbFields, 'published')) {
    allDbFields.push(createAutoField('published', 'boolean'))
  }

  if (!getSchemaFieldByName(allDbFields, 'createdAt')) {
    allDbFields.push(createAutoField('createdAt', 'timestamp'))
  }

  if (!getSchemaFieldByName(allDbFields, 'updatedAt')) {
    allDbFields.push(createAutoField('updatedAt', 'timestamp'))
  }

  for (const field of createAuthorshipFields()) {
    if (!getSchemaFieldByName(allDbFields, field.name)) {
      allDbFields.push(field)
    }
  }

  if (!getSchemaFieldByName(allDbFields, 'sortOrder')) {
    allDbFields.push(createAutoField('sortOrder', 'number'))
  }

  return {
    dbFields,
    regularDbFields,
    allDbFields
  }
}
